import * as React from 'react'

import { Box, Icon } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import Select from 'modules/core/components/Inputs/Select'
import Popover from 'modules/core/components/Popover'
import { trackingEvents } from 'modules/core/lib/Tracking/events'
import i18n from 'modules/core/lib/i18n'

import { useReportTracking } from 'modules/reports/hooks/useReportTracking'
import { translateAggregationFunction } from 'modules/reports/lib/Constants'
import { aggregationFunctions } from 'modules/reports/lib/fieldHelper'
import type Field from 'modules/reports/store/models/Field'

type FieldType = {
  field: Field
  form: Form
}

interface Props {
  field: FieldType
}

const Options = ({ field }: Props) => {
  const [open, setOpen] = React.useState(false)

  const { track } = useReportTracking()

  const handleChange = () => {
    track(trackingEvents.reports.aggregationChanged, {
      aggregation: field.form.get('function').value,
      field: field.field.attributes?.path,
    })
  }

  const options = (field: Field) => {
    return aggregationFunctions(field).map((value) => ({
      value,
      label: translateAggregationFunction(value),
    }))
  }

  return (
    <Box flexDirection="row">
      <Popover
        overflowContent
        attachment="middle left"
        size="big"
        toggle={(v) => () => setOpen(v)}
        open={open}
      >
        <Box cursor="pointer">
          <Icon.Small icon="pencil" color="grey600" />
        </Box>
        <Box padding="s24" gap="s12">
          <Select
            none={i18n.t('common.none')}
            label={i18n.t('custom_reports.ability_labels.aggregate_by')}
            field={field.form.get('function')}
            options={options(field.field)}
            onChange={handleChange}
          />
        </Box>
      </Popover>
    </Box>
  )
}

export default Options
